import React, { PropsWithChildren } from "react";

const PhoneIcon = (props: PropsWithChildren<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="17"
      fill="none"
      viewBox="0 0 10 17"
    >
      <path
        fill="#522398"
        d="M7 3.75v7.5H3v-7.5h4zm1.5-3h-7A1.5 1.5 0 000 2.25v13c0 .844.656 1.5 1.5 1.5h7a1.5 1.5 0 001.5-1.5v-13c0-.813-.688-1.5-1.5-1.5zm-7 15a.494.494 0 01-.5-.5v-13c0-.25.219-.5.5-.5h7c.25 0 .5.25.5.5v13c0 .281-.25.5-.5.5h-7zm6.125-13h-5.25A.38.38 0 002 3.125v8.75c0 .219.156.375.375.375h5.25A.38.38 0 008 11.875v-8.75a.403.403 0 00-.375-.375zm-1.5 11h-2.25a.38.38 0 00-.375.375v.25c0 .219.156.375.375.375h2.25a.38.38 0 00.375-.375v-.25a.403.403 0 00-.375-.375z"
      ></path>
    </svg>
  );
};

export default React.memo(PhoneIcon);
